export const yAxisMaxMin = {
  max: (value: { min: number; max: number }): number => {
    if (!value?.max && !value?.min) return 100
    const val = Math.max(Math.abs(value.min), Math.abs(value.max)) * 1.2

    // Round to nice numbers
    if (val >= 1000000) {
      // Round to nearest million
      return Math.ceil(val / 1000000) * 1000000
    } else if (val >= 100000) {
      // Round to nearest 100k
      return Math.ceil(val / 100000) * 100000
    } else if (val >= 10000) {
      // Round to nearest 10k
      return Math.ceil(val / 10000) * 10000
    } else if (val >= 1000) {
      // Round to nearest 1k
      return Math.ceil(val / 1000) * 1000
    } else {
      return Math.ceil(val / 100) * 100
    }
  },

  min: (value: { min: number; max: number }): number => {
    if (!value?.max && !value?.min) return -100
    const val = Math.max(Math.abs(value.min), Math.abs(value.max)) * 1.2

    // Round to nice numbers (negative)
    if (val >= 1000000) {
      return Math.ceil(val / 1000000) * -1000000
    } else if (val >= 100000) {
      return Math.ceil(val / 100000) * -100000
    } else if (val >= 10000) {
      return Math.ceil(val / 10000) * -10000
    } else if (val >= 1000) {
      return Math.ceil(val / 1000) * -1000
    } else {
      return Math.ceil(val / 100) * -100
    }
  },
}
